define([
    "./simulationModule",
    "./simulationUrls",
    "./simulationDrawerService",
    "./simulationService",
    "./nlgSimulationDrawer"
], function () {});